export const EXPORT_COLUMNS_ASSETS = {
  id: 'Id',
  asset_name: 'Asset Name',
  asset_subtype: 'Asset Subtype',
  asset_type: 'Asset Type',
  created_at: 'Created At',
  criticality: 'Criticality',
  data_provider: 'Data Provider',
  description: 'Description',
  domain: 'Domain',
  ip_address: 'IP Address',
  last_seen_at: 'Last Seen At',
  has_agent: 'Has Agent',
  operating_system: 'Operating System',
  organization_id: 'Organization Id',
  organization_name: 'Organization Name',
  risk_score: 'Risk Score',
  updated_at: 'Updated At',
  user_updated_at: 'User Updated At'
};

export default EXPORT_COLUMNS_ASSETS;
